import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Lightbox, LightboxConfig } from 'ngx-lightbox';
// import { NgxSpinnerService } from "ngx-spinner";
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';


@Component({
  selector: 'app-works',
  templateUrl: './works.component.html',
  styleUrls: ['./works.component.css']
})
export class WorksComponent implements OnInit {

  activeTab_all = 'active';
  activeTab_branding = '';
  activeTab_digital = '';
  activeTab_tv = '';
  activeTab_animation = '';
  activeTab_news_letter = '';
  activeTab_logo = '';


  ngOnInit(): void {
    // window.location.reload();

    // /** spinner starts on init */
    // this.spinner.show();

    // setTimeout(() => {
    //   /** spinner ends after 5 seconds */
    //   this.spinner.hide();
    // }, 5000);

    fromEvent(window, 'scroll')
      .pipe(debounceTime(this.throttle))
      .subscribe(() => this.onScroll(null));

  }

  items: any[] = [];
  page: number = 0;
  itemsPerPage: number = 5; // Number of items to load per page
  isLoading: boolean = false;
  throttle = 300; // Throttle time in milliseconds
  scrollDistance = 1000; // Distance from bottom to trigger
  hasMoreItems: boolean = true;



  album: any = [];
  albumClone;
  filteredAlbum: any[] = [];


  constructor(private _lightbox: Lightbox,
    private _lightboxConfig: LightboxConfig,
    @Inject(DOCUMENT) private doc,
    private elementRef: ElementRef,
    private router: Router,
    // private spinner: NgxSpinnerService
  ) {

    // _lightboxConfig.fadeDuration = 1;

    this.cardsPush();
    this.albumClone = Object.assign([], this.album);

    // descending
    this.album = this.album.sort((a, b) => b.index - a.index);

    //ascending
    // this.album = this.album.sort((a, b) => a.index - b.index);

    // Set initial filtered array
    this.filteredAlbum = [...this.album];
    this.filter('branding');
    this.loadMoreItems(); // Load the first page when component initializes

  }

  open(index: number): void {

    // this._lightbox.open(this.album, index);
    this._lightbox.open(this.items, index, { wrapAround: true, showImageNumberLabel: true, disableScrolling: true, centerVertically: true });
  }

  close(): void {

    this._lightbox.close();
  }

  cardsPush() {
    // Captain Campaign
    this.album.push({
      'src': 'assets/img/work/main-page/200.jpg',
      'caption': 'Captain Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-200.jpg',
      'type': 'page',
      'link': '/works/captain',
      'class': 'digital',
      'index': 60
    });
    this.album.push({
      'src': 'assets/img/work/main-page/1.jpg', 'caption': 'Seylan Bank Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-1.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'branding', 'index': 51
    });

    // Seylan Bank Personla Loan Campaign
    this.album.push({
      'src': 'assets/img/work/main-page/2.jpg', 'caption': 'Seylan Bank Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-2.jpg',
      'type': 'page', 'link': '/works/seylan-bank-2', 'class': 'branding', "index": 2
    });

    //Seylan Bank Ran Naya
    this.album.push({
      'src': 'assets/img/work/main-page/3.jpg', 'caption': 'Seylan Bank Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-3.jpg',
      'type': 'page', 'link': '/works/seylan-bank-3', 'class': 'branding', "index": 3
    });
    this.album.push({
      'src': 'assets/img/work/main-page/4.jpg', 'caption': 'Seylan Bank Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-4.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'branding', "index": 54
    });
    this.album.push({
      'src': 'assets/img/work/main-page/7.jpg', 'caption': 'Seylan Bank Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-7.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'branding', "index": 55
    });

    // Toyota lanka Campaign
    this.album.push({
      'src': 'assets/img/work/main-page/5.jpg', 'caption': 'Toyota Lanka Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-5.jpg',
      'type': 'page', 'link': '/works/toyoto-lanka', 'class': 'branding', "index": 6
    });


    // Seylan Bank Avurudu Campaign
    this.album.push({
      'src': 'assets/img/work/main-page/6.jpg', 'caption': 'Seylan Bank Avurudu Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-6.jpg',
      'type': 'page', 'link': '/works/seylan-bank', 'class': 'branding', "index": 7
    });

    this.album.push({
      'src': 'assets/img/work/main-page/8.jpg', 'caption': 'Seylan Bank Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-8.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'branding', "index": 58
    });

    // Foot Mania Ad Campaign
    this.album.push({
      'src': 'assets/img/work/foot-mania/1.jpg', 'caption': 'Foot Mania Ad Campaign', 'thumb': 'assets/img/work/foot-mania/thumbs/work-1.jpg',
      'type': 'page', 'link': '/works/foot-mania', 'class': 'branding', "index": 9
    });

    this.album.push({
      'src': 'assets/img/work/main-page/9.jpg', 'caption': 'Seylan Bank Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-9.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'branding', "index": 59
    });

    // Spa Ceylon Campaign
    this.album.push({
      'src': 'assets/img/work/main-page/10.jpg', 'caption': 'Spa Ceylon Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-10.jpg',
      'type': 'page', 'link': '/works/spa-ceylon', 'class': 'animation', "index": 11
    });


    // AMW Campaign
    this.album.push({
      'src': 'assets/img/work/main-page/11.jpg', 'caption': 'AMW Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-11.jpg',
      'type': 'page', 'link': '/works/amw', 'class': 'animation', "index": 13
    });

    // Spinner Campaign
    this.album.push({
      'src': 'assets/img/work/main-page/12.jpg', 'caption': 'Spinner Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-12.jpg',
      'type': 'page', 'link': '/works/spinner', 'class': 'digital', "index": 12
    });

    //Heros Of the Heart
    this.album.push({
      'src': 'assets/img/work/main-page/13.jpg', 'caption': 'Heros of the Heart Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-13.jpg',
      'type': 'page', 'link': '/works/seylan-bank-4', 'class': 'animation', "index": 13
    });

    // this.album.push({
    //   'src': 'assets/img/work/main-page/14.jpg', 'caption': 'Seylan Bank Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-14.jpg',
    //   'type': 'image', 'link': '/works/seylan-bank-4', 'class': 'branding', "index": 14
    // });

    this.album.push({
      'src': 'assets/img/work/main-page/15.jpg', 'caption': 'Singha Lanka Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-15.jpg',
      'type': 'page', 'link': '/works/sinha', 'class': 'digital', "index": 15
    });

    this.album.push({
      'src': 'assets/img/work/main-page/16.jpg', 'caption': 'Seylan Mega Rewards Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-16.jpg',
      'type': 'page', 'link': '/works/seylan-bank-5', 'class': 'branding', "index": 16
    });


    this.album.push({
      'src': 'assets/img/work/main-page/17.jpg', 'caption': 'Seylan Tikiri Panel Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-17.jpg',
      'type': 'page', 'link': '/works/seylan-bank-6', 'class': 'branding', "index": 17
    });

    // this.album.push({
    //   'src': 'assets/img/work/main-page/18.jpg', 'caption': 'Seylan Bank TV Commercials', 'thumb': 'assets/img/work/main-page/thumbs/work-18.jpg',
    //   'type': 'page', 'link': '/works/seylan-bank-7', 'class': 'tv', "index": 18
    // });

    this.album.push({
      'src': 'assets/img/work/main-page/19.jpg', 'caption': 'Seylan Bank Quarterly E News Letter', 'thumb': 'assets/img/work/main-page/thumbs/work-19.jpg',
      'type': 'page', 'link': '/works/seylan-bank-8', 'class': 'news-letter', "index": 19
    });

    this.album.push({
      'src': 'assets/img/work/main-page/20.jpg', 'caption': 'Seylan Bank Rugby Logo', 'thumb': 'assets/img/work/main-page/thumbs/work-20.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'logo', "index": 20
    });

    this.album.push({
      'src': 'assets/img/work/main-page/21.jpg', 'caption': 'Seylan Bank Rugby Logo', 'thumb': 'assets/img/work/main-page/thumbs/work-21.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'logo', "index": 21
    });

    this.album.push({
      'src': 'assets/img/work/main-page/22.jpg', 'caption': 'Seylan Logo', 'thumb': 'assets/img/work/main-page/thumbs/work-22.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'logo', "index": 22
    });

    this.album.push({
      'src': 'assets/img/work/main-page/23.jpg', 'caption': 'Seylan Logo', 'thumb': 'assets/img/work/main-page/thumbs/work-23.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'logo', "index": 23
    });


    // Different Image Locations

    this.album.push({
      'src': 'assets/img/work/seylan-goald-loan/1.jpg', 'caption': 'Seylan TV Commercials Campaign', 'thumb': 'assets/img/work/seylan-goald-loan/thumbs/work-1.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/FacZnupW1mg', 'class': 'tv', "index": 24
    });


    this.album.push({
      'src': 'assets/img/work/seylan-goald-loan/2.jpg', 'caption': 'Seylan TV Commercials Campaign', 'thumb': 'assets/img/work/seylan-goald-loan/thumbs/work-2.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/R8BzBe1pRQM', 'class': 'tv', "index": 25
    });


    this.album.push({
      'src': 'assets/img/work/seylan-goald-loan/3.jpg', 'caption': 'Seylan TV Commercials Campaign', 'thumb': 'assets/img/work/seylan-goald-loan/thumbs/work-3.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/Y17lsdmhoeg', 'class': 'tv', "index": 26
    });


    this.album.push({
      'src': 'assets/img/work/seylan-goald-loan/4.jpg', 'caption': 'Seylan TV Commercials Campaign', 'thumb': 'assets/img/work/seylan-goald-loan/thumbs/work-4.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/pKWSaOLcp3k', 'class': 'tv', "index": 27
    });


    this.album.push({
      'src': 'assets/img/work/spinner/7.jpg', 'caption': 'Spinner Ad Campaign', 'thumb': 'assets/img/work/spinner/thumbs/work-7.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/daNqT1dojeQ', 'class': 'animation', "index": 28
    });

    this.album.push({
      'src': 'assets/img/work/spinner/8.jpg', 'caption': 'Spinner Ad Campaign', 'thumb': 'assets/img/work/spinner/thumbs/work-8.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/yhPcmcEYvyE', 'class': 'animation', "index": 29
    });


    this.album.push({
      'src': 'assets/img/work/spinner/9.jpg', 'caption': 'Spinner Ad Campaign', 'thumb': 'assets/img/work/spinner/thumbs/work-9.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/Gi4eEQozj1A', 'class': 'animation', "index": 30
    });

    this.album.push({
      'src': 'assets/img/work/sinha/17.jpg', 'caption': 'Singha Lanka Campaign', 'thumb': 'assets/img/work/sinha/thumbs/work-17.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/iMrcrKu4opM', 'class': 'animation', "index": 31
    });

    this.album.push({
      'src': 'assets/img/work/main-page/32.jpg', 'caption': 'Seylan SME Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-32.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/2oJmusYKi48', 'class': 'animation', "index": 32
    });


    this.album.push({
      'src': 'assets/img/work/main-page/33.jpg', 'caption': 'Seylan SMECampaign', 'thumb': 'assets/img/work/main-page/thumbs/work-33.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/qbNvlCDSDtY', 'class': 'animation', "index": 33
    });


    this.album.push({
      'src': 'assets/img/work/main-page/34.jpg', 'caption': 'Seylan SME Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-34.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/vJZJG4-bACs', 'class': 'animation', "index": 34
    });


    this.album.push({
      'src': 'assets/img/work/main-page/35.jpg', 'caption': 'Seylan SME Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-35.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/Rbcp7mux-og', 'class': 'animation', "index": 35
    });



    this.album.push({
      'src': 'assets/img/work/main-page/36.jpg', 'caption': 'Singha Lanka Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-36.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/Ont-A6SioOE', 'class': 'animation', "index": 36
    });

    this.album.push({
      'src': 'assets/img/work/main-page/37.jpg', 'caption': 'Seylan Tikiri', 'thumb': 'assets/img/work/main-page/thumbs/work-37.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/yXaI8WfEC3k', 'class': 'tv', "index": 37
    });


    this.album.push({
      'src': 'assets/img/work/main-page/38.jpg', 'caption': 'Seylan Golad Loan', 'thumb': 'assets/img/work/main-page/thumbs/work-38.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/o17chL8qShg', 'class': 'tv', "index": 38
    });

    this.album.push({
      'src': 'assets/img/work/main-page/39.jpg', 'caption': 'Seylan Bank', 'thumb': 'assets/img/work/main-page/thumbs/work-39.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'branding', "index": 39
    });

    this.album.push({
      'src': 'assets/img/work/main-page/40.jpg', 'caption': 'Seylan Bank', 'thumb': 'assets/img/work/main-page/thumbs/work-40.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'branding', "index": 39
    });

    this.album.push({
      'src': 'assets/img/work/main-page/41.jpg', 'caption': 'Seylan Bank', 'thumb': 'assets/img/work/main-page/thumbs/work-41.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'branding', "index": 39
    });

    this.album.push({
      'src': 'assets/img/work/main-page/42.jpg', 'caption': 'Seylan Bank', 'thumb': 'assets/img/work/main-page/thumbs/work-42.jpg',
      'type': 'image', 'link': '/works/seylan-bank', 'class': 'branding', "index": 39
    });

    this.album.push({
      'src': 'assets/img/work/main-page/43.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-43.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/R3aYoISFz14', 'class': 'animation', "index": 4994
    });

    this.album.push({
      'src': 'assets/img/work/main-page/44.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-44.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/vXfGO0bbZMk', 'class': 'animation', "index": 4993
    });

    this.album.push({
      'src': 'assets/img/work/main-page/45.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-45.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/BnJi3MnH5P4', 'class': 'animation', "index": 4992
    });

    this.album.push({
      'src': 'assets/img/work/main-page/46.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-46.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/VFrVoVL4w7c', 'class': 'animation', "index": 4991
    });

    this.album.push({
      'src': 'assets/img/work/main-page/47.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-47.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/CtdCc-gkDy4', 'class': 'animation', "index": 4990
    });

    this.album.push({
      'src': 'assets/img/work/main-page/48.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-48.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/xVqvlyfDqXQ', 'class': 'animation', "index": 4989
    });

    this.album.push({
      'src': 'assets/img/work/main-page/49.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-49.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/8Djj5aJcsa8', 'class': 'animation', "index": 4988
    });

    this.album.push({
      'src': 'assets/img/work/main-page/50.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-50.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/1FT8pK4x2j4', 'class': 'animation', "index": 4987
    });

    this.album.push({
      'src': 'assets/img/work/main-page/51.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-51.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/fHFdamv9R5Y', 'class': 'animation', "index": 4986
    });

    this.album.push({
      'src': 'assets/img/work/main-page/52.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-52.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/S9GmRrPtpKY', 'class': 'animation', "index": 4985
    });



    this.album.push({
      'src': 'assets/img/work/main-page/53.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-53.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/5sdFaWUK3Tc', 'class': 'animation', "index": 4998
    });


    this.album.push({
      'src': 'assets/img/work/main-page/54.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-54.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/PCo6KpHb-Yw', 'class': 'animation', "index": 4996
    });


    this.album.push({
      'src': 'assets/img/work/main-page/55.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-55.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/8XNa8cW87u8', 'class': 'animation', "index": 4995
    });

    this.album.push({
      'src': 'assets/img/work/main-page/56.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-56.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/KFcwxzzGNwg', 'class': 'animation', "index": 4997
    });

    this.album.push({
      'src': 'assets/img/work/main-page/57.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-57.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/uHgIEnF-1Wk', 'class': 'animation', "index": 64
    });

    this.album.push({
      'src': 'assets/img/work/main-page/58.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-58.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/-u7Ucr2amzs', 'class': 'animation', "index": 65
    });

    this.album.push({
      'src': 'assets/img/work/main-page/59.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-59.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/_EfD-gTig-E', 'class': 'animation', "index": 66
    });

    this.album.push({
      'src': 'assets/img/work/main-page/60.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-60.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/LgkOczJ6PhU', 'class': 'animation', "index": 67
    });

    this.album.push({
      'src': 'assets/img/work/main-page/61.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-61.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/ALdxbXdy4Mc', 'class': 'animation', "index": 68
    });

    this.album.push({
      'src': 'assets/img/work/main-page/62.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-62.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/soYWjm7a4wE', 'class': 'animation', "index": 69
    });

    this.album.push({
      'src': 'assets/img/work/main-page/63.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-63.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/yFkYpsb19Ck', 'class': 'tv', "index": 70
    });

    this.album.push({
      'src': 'assets/img/work/main-page/64.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-64.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/MY6f8KC8Pms', 'class': 'tv', "index": 71
    });

    this.album.push({
      'src': 'assets/img/work/main-page/65.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-65.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/kq4yxlFjD-U', 'class': 'tv', "index": 72
    });

    this.album.push({
      'src': 'assets/img/work/main-page/66.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-66.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/Vav0BZGJwC4', 'class': 'tv', "index": 73
    });

    this.album.push({
      'src': 'assets/img/work/main-page/67.jpg', 'caption': 'Seylan Bank App', 'thumb': 'assets/img/work/main-page/thumbs/work-67.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/qbIoJIVKM_U', 'class': 'tv', "index": 73
    });





    this.album.push({
      'src': 'assets/img/work/main-page/68.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-68.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': 80
    });

    this.album.push({
      'src': 'assets/img/work/main-page/69.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-69.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': 81
    });

    // this.album.push({
    //   'src': 'assets/img/work/main-page/70.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-70.jpg',
    //   'type': 'image', 'link': '/works', 'class': 'branding', 'index': 82
    // });

    this.album.push({
      'src': 'assets/img/work/main-page/71.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-71.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': 83
    });

    // this.album.push({
    //   'src': 'assets/img/work/main-page/72.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-72.jpg',
    //   'type': 'image', 'link': '/works', 'class': 'branding', 'index': 84
    // });

    // this.album.push({
    //   'src': 'assets/img/work/main-page/73.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-73.jpg',
    //   'type': 'image', 'link': '/works', 'class': 'branding', 'index': 85
    // });

    this.album.push({
      'src': 'assets/img/work/main-page/74.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-74.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': 86
    });

    this.album.push({
      'src': 'assets/img/work/main-page/75.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-75.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': 87
    });

    this.album.push({
      'src': 'assets/img/work/main-page/76.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-76.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': 88
    });

    this.album.push({
      'src': 'assets/img/work/main-page/77.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-77.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': 89
    });

    this.album.push({
      'src': 'assets/img/work/main-page/78.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-78.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': 90
    });

    //Japan Poster Set Start //

    this.album.push({
      'src': 'assets/img/work/main-page/79.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-79.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': -1
    });

    this.album.push({
      'src': 'assets/img/work/main-page/80.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-80.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': -2
    });

    this.album.push({
      'src': 'assets/img/work/main-page/81.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-81.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': -3
    });

    this.album.push({
      'src': 'assets/img/work/main-page/82.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-82.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': -4
    });

    this.album.push({
      'src': 'assets/img/work/main-page/83.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-83.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': -5
    });

    this.album.push({
      'src': 'assets/img/work/main-page/84.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-84.jpg',
      'type': 'image', 'link': '/works', 'class': 'branding', 'index': -6
    });

    //Japan Poster Set END //

    this.album.push({
      'src': 'assets/img/work/main-page/85.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-85.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/Rmopr_3yX5Q', 'class': 'tv', "index": 97
    });

    this.album.push({
      'src': 'assets/img/work/main-page/86.jpg', 'caption': 'Ad Campaign', 'thumb': 'assets/img/work/main-page/thumbs/work-86.jpg',
      'type': 'video', 'link': 'https://www.youtube.com/embed/ZFisZP4AzR4', 'class': 'tv', "index": 98
    });



    this.album.push({
      'src': 'assets/img/work/main-page/87.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-87.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/30q6zEycekU',
      'class': 'animation',
      "index": 101
    });
    this.album.push({
      'src': 'assets/img/work/main-page/88.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-88.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/Q6afjiBdB7U',
      'class': 'animation',
      "index": 4949
    });
    this.album.push({
      'src': 'assets/img/work/main-page/89.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-89.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/zKrHXJECHyU',
      'class': 'animation',
      "index": 4948
    });
    this.album.push({
      'src': 'assets/img/work/main-page/90.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-90.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/osy23Op0J-A',
      'class': 'animation',
      "index": 4947
    });
    this.album.push({
      'src': 'assets/img/work/main-page/91.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-91.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/rQ2XgoFNSKc',
      'class': 'animation',
      "index": 4946
    });
    this.album.push({
      'src': 'assets/img/work/main-page/92.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-92.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/yBK1tTD3Fbc',
      'class': 'animation',
      "index": 4945
    });
    this.album.push({
      'src': 'assets/img/work/main-page/93.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-93.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/luOLOpDz3nA',
      'class': 'animation',
      "index": 4944
    });
    this.album.push({
      'src': 'assets/img/work/main-page/94.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-94.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/lHhjSDstDwo',
      'class': 'animation',
      "index": 4943
    });


    // Entries for 95.jpg, 96.jpg, 97.jpg, 125.jpg, and 128.jpg have been moved to the Captain page


    this.album.push({
      'src': 'assets/img/work/main-page/98.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-98.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 112
    });

    this.album.push({
      'src': 'assets/img/work/main-page/99.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-99.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 113
    });

    this.album.push({
      'src': 'assets/img/work/main-page/100.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-100.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 114
    });

    this.album.push({
      'src': 'assets/img/work/main-page/101.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-101.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 115
    });

    this.album.push({
      'src': 'assets/img/work/main-page/102.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-102.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 116
    });

    this.album.push({
      'src': 'assets/img/work/main-page/103.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-103.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 117
    });

    this.album.push({
      'src': 'assets/img/work/main-page/104.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-104.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 118
    });

    this.album.push({
      'src': 'assets/img/work/main-page/105.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-105.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 119
    });

    this.album.push({
      'src': 'assets/img/work/main-page/106.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-106.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 120
    });

    this.album.push({
      'src': 'assets/img/work/main-page/107.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-107.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 121
    });

    this.album.push({
      'src': 'assets/img/work/main-page/108.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-108.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 122
    });

    this.album.push({
      'src': 'assets/img/work/main-page/109.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-109.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 123
    });

    this.album.push({
      'src': 'assets/img/work/main-page/110.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-110.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 124
    });

    this.album.push({
      'src': 'assets/img/work/main-page/111.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-111.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 125
    });

    this.album.push({
      'src': 'assets/img/work/main-page/112.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-112.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 126
    });

    this.album.push({
      'src': 'assets/img/work/main-page/113.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-113.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 127
    });

    this.album.push({
      'src': 'assets/img/work/main-page/114.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-114.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 128
    });

    this.album.push({
      'src': 'assets/img/work/main-page/115.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-115.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 129
    });

    this.album.push({
      'src': 'assets/img/work/main-page/116.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-116.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 130
    });

    this.album.push({
      'src': 'assets/img/work/main-page/117.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-117.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 131
    });

    this.album.push({
      'src': 'assets/img/work/main-page/118.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-118.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 132
    });

    this.album.push({
      'src': 'assets/img/work/main-page/119.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-119.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 133
    });

    this.album.push({
      'src': 'assets/img/work/main-page/120.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-120.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 134
    });

    this.album.push({
      'src': 'assets/img/work/main-page/121.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-121.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 135
    });

    this.album.push({
      'src': 'assets/img/work/main-page/122.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-122.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 136
    });

    this.album.push({
      'src': 'assets/img/work/main-page/123.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-123.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 137
    });

    this.album.push({
      'src': 'assets/img/work/main-page/124.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-124.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 138
    });

    this.album.push({
      'src': 'assets/img/work/main-page/126.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-126.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 139
    });

    this.album.push({
      'src': 'assets/img/work/main-page/127.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-127.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 140
    });


    this.album.push({
      'src': 'assets/img/work/main-page/129.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-129.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 143
    });

    this.album.push({
      'src': 'assets/img/work/main-page/130.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-130.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 144
    });

    this.album.push({
      'src': 'assets/img/work/main-page/131.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-131.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 145
    });

    this.album.push({
      'src': 'assets/img/work/main-page/132.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-132.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 146
    });

    this.album.push({
      'src': 'assets/img/work/main-page/133.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-133.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 147
    });

    this.album.push({
      'src': 'assets/img/work/main-page/134.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-134.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 148
    });

    this.album.push({
      'src': 'assets/img/work/main-page/135.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-135.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 149
    });

    this.album.push({
      'src': 'assets/img/work/main-page/136.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-136.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 150
    });

    this.album.push({
      'src': 'assets/img/work/main-page/137.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-137.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 151
    });

    this.album.push({
      'src': 'assets/img/work/main-page/138.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-138.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 152
    });

    this.album.push({
      'src': 'assets/img/work/main-page/139.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-139.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 153
    });

    this.album.push({
      'src': 'assets/img/work/main-page/140.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-140.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 154
    });

    this.album.push({
      'src': 'assets/img/work/main-page/141.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-141.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 155
    });

    this.album.push({
      'src': 'assets/img/work/main-page/142.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-142.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'logo',
      'index': 156
    });

    this.album.push({
      'src': 'assets/img/work/main-page/143.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-143.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 157
    });


    this.album.push({
      'src': 'assets/img/work/main-page/145.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-145.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 159
    });

    this.album.push({
      'src': 'assets/img/work/main-page/146.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-146.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 160
    });

    this.album.push({
      'src': 'assets/img/work/main-page/147.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-147.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 161
    });

    this.album.push({
      'src': 'assets/img/work/main-page/148.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-148.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 162
    });

    this.album.push({
      'src': 'assets/img/work/main-page/149.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-149.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 163
    });

    this.album.push({
      'src': 'assets/img/work/main-page/150.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-150.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 164
    });

    this.album.push({
      'src': 'assets/img/work/main-page/151.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-151.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 165
    });

    this.album.push({
      'src': 'assets/img/work/main-page/152.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-152.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 166
    });

    this.album.push({
      'src': 'assets/img/work/main-page/153.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-153.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 167
    });

    this.album.push({
      'src': 'assets/img/work/main-page/154.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-154.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 168
    });

    this.album.push({
      'src': 'assets/img/work/main-page/155.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-155.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 169
    });

    this.album.push({
      'src': 'assets/img/work/main-page/156.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-156.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 170
    });

    this.album.push({
      'src': 'assets/img/work/main-page/157.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-157.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 171
    });

    this.album.push({
      'src': 'assets/img/work/main-page/158.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-158.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 172
    });

    this.album.push({
      'src': 'assets/img/work/main-page/159.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-159.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 173
    });

    this.album.push({
      'src': 'assets/img/work/main-page/160.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-160.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 174
    });

    this.album.push({
      'src': 'assets/img/work/main-page/161.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-161.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 175
    });

    this.album.push({
      'src': 'assets/img/work/main-page/162.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-162.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 176
    });

    this.album.push({
      'src': 'assets/img/work/main-page/163.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-163.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 177
    });

    this.album.push({
      'src': 'assets/img/work/main-page/164.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-164.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 178
    });

    this.album.push({
      'src': 'assets/img/work/main-page/165.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-165.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 179
    });




    this.album.push({
      'src': 'assets/img/work/main-page/166.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-166.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/vI3QNenEOX4',
      'class': 'animation',
      'index': 180
    });
    this.album.push({
      'src': 'assets/img/work/main-page/167.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-167.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/BI5EnUO4A_4',
      'class': 'animation',
      'index': 181
    });
    this.album.push({
      'src': 'assets/img/work/main-page/168.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-168.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/OyVyhG8voHY',
      'class': 'animation',
      'index': 182
    });
    this.album.push({
      'src': 'assets/img/work/main-page/169.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-169.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/1AiZfuh7jY4',
      'class': 'animation',
      'index': 183
    });
    this.album.push({
      'src': 'assets/img/work/main-page/170.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-170.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/FO0lQ_cuVxE',
      'class': 'animation',
      'index': 184
    });
    this.album.push({
      'src': 'assets/img/work/main-page/171.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-171.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/fqzW_xY5JT0',
      'class': 'animation',
      'index': 185
    });
    this.album.push({
      'src': 'assets/img/work/main-page/172.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-172.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/rijKKaKtRpE',
      'class': 'animation',
      'index': 186
    });
    this.album.push({
      'src': 'assets/img/work/main-page/173.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-173.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/kEN4W5H1Atw',
      'class': 'animation',
      'index': 187
    });
    this.album.push({
      'src': 'assets/img/work/main-page/174.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-174.jpg',
      'type': 'pdf',
      'link': 'assets/img/work/main-page/pdf/01-union-assuarance.pdf',
      'class': 'branding',
      'index': 197
    });
    this.album.push({
      'src': 'assets/img/work/main-page/175.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-175.jpg',
      'type': 'pdf',
      'link': 'assets/img/work/main-page/pdf/02-seylan.pdf',
      'class': 'branding',
      'index': 189
    });

    this.album.push({
      'src': 'assets/img/work/main-page/177.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-177.jpg',
      'type': 'pdf',
      'link': 'assets/img/work/main-page/pdf/04-seylan-bethi-gee-harasara-2024.pdf',
      'class': 'branding',
      'index': 191
    });
    this.album.push({
      'src': 'assets/img/work/main-page/178.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-178.jpg',
      'type': 'pdf',
      'link': 'assets/img/work/main-page/pdf/05-seylan-english-hit-ads.pdf',
      'class': 'branding',
      'index': 192
    });
    this.album.push({
      'src': 'assets/img/work/main-page/179.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-179.jpg',
      'type': 'pdf',
      'link': 'assets/img/work/main-page/pdf/06-seylan-sinhala-lahipita.pdf',
      'class': 'branding',
      'index': 193
    });
    this.album.push({
      'src': 'assets/img/work/main-page/180.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-180.jpg',
      'type': 'pdf',
      'link': 'assets/img/work/main-page/pdf/07-seylan-stall.pdf',
      'class': 'branding',
      'index': 194
    });
    this.album.push({
      'src': 'assets/img/work/main-page/181.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-181.jpg',
      'type': 'pdf',
      'link': 'assets/img/work/main-page/pdf/08-seylan-stal.pdf',
      'class': 'branding',
      'index': 195
    });
    this.album.push({
      'src': 'assets/img/work/main-page/182.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-182.jpg',
      'type': 'pdf',
      'link': 'assets/img/work/main-page/pdf/09-seylan-stall.pdf',
      'class': 'branding',
      'index': 196
    });

    this.album.push({
      'src': 'assets/img/work/main-page/183.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-183.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 188
    });

    this.album.push({
      'src': 'assets/img/work/main-page/184.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-184.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 198
    });

    this.album.push({
      'src': 'assets/img/work/main-page/185.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-185.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 199
    });

    this.album.push({
      'src': 'assets/img/work/main-page/186.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-186.jpg',
      'type': 'image',
      'link': '/works',
      'class': 'branding',
      'index': 200
    });

    this.album.push({
      'src': 'assets/img/work/main-page/187.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-187.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/ukrkxdV61kU',
      'class': 'animation',
      'index': 201
    });

    this.album.push({
      'src': 'assets/img/work/main-page/188.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-188.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/rJ_CKGP_KSs',
      'class': 'animation',
      'index': 202
    });

    this.album.push({
      'src': 'assets/img/work/main-page/189.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-189.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/7s0H5xvH-vk',
      'class': 'animation',
      'index': 4899
    });

    this.album.push({
      'src': 'assets/img/work/main-page/190.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-190.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/b5LqvN11jDM',
      'class': 'animation',
      'index': 204
    });

    this.album.push({
      'src': 'assets/img/work/main-page/191.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-191.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/7UsvshwQ0Ew',
      'class': 'animation',
      'index': 205
    });

    this.album.push({
      'src': 'assets/img/work/main-page/192.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-192.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/EOXCFNfdwlc',
      'class': 'animation',
      'index': 206
    });

    this.album.push({
      'src': 'assets/img/work/main-page/193.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-193.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/DOcwHEtbiIQ',
      'class': 'animation',
      'index': 207
    });

    this.album.push({
      'src': 'assets/img/work/main-page/194.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-194.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/1NNMj4l7PlE',
      'class': 'animation',
      'index': 208
    });

    this.album.push({
      'src': 'assets/img/work/main-page/195.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-195.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/WsiYjiy6SYE',
      'class': 'tv',
      'index': 209
    });

    this.album.push({
      'src': 'assets/img/work/main-page/196.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-196.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/A6fgewI4img',
      'class': 'tv',
      'index': 210
    });

    this.album.push({
      'src': 'assets/img/work/main-page/197.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-197.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/JArKrC3vsvE',
      'class': 'animation',
      'index': 211
    });

    this.album.push({
      'src': 'assets/img/work/main-page/198.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-198.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/jPmjZXpIpqk',
      'class': 'animation',
      'index': 212
    });

    this.album.push({
      'src': 'assets/img/work/main-page/205.jpg',
      'caption': 'NDB',
      'thumb': 'assets/img/work/main-page/thumbs/work-205.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/TO80ck6pJE4',
      'class': 'animation',
      'index': 213
    });

    this.album.push({
      'src': 'assets/img/work/main-page/206.jpg',
      'caption': 'NDB',
      'thumb': 'assets/img/work/main-page/thumbs/work-206.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/GiJtYoOyOhc',
      'class': 'animation',
      'index': 214
    });

    this.album.push({
      'src': 'assets/img/work/main-page/207.jpg',
      'caption': 'NDB',
      'thumb': 'assets/img/work/main-page/thumbs/work-207.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/hEIj8c_A2As',
      'class': 'animation',
      'index': 215
    });

    this.album.push({
      'src': 'assets/img/work/main-page/208.jpg',
      'caption': 'NDB',
      'thumb': 'assets/img/work/main-page/thumbs/work-208.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/rxOyM58d93w',
      'class': 'animation',
      'index': 216
    });

    this.album.push({
      'src': 'assets/img/work/main-page/209.jpg',
      'caption': 'NDB',
      'thumb': 'assets/img/work/main-page/thumbs/work-209.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/v02wrB4l9iM',
      'class': 'animation',
      'index': 217
    });

    this.album.push({
      'src': 'assets/img/work/main-page/210.jpg',
      'caption': 'NDB',
      'thumb': 'assets/img/work/main-page/thumbs/work-210.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/WxsQ8oAApOE',
      'class': 'animation',
      'index': 218
    });

    this.album.push({
      'src': 'assets/img/work/main-page/211.jpg',
      'caption': 'NDB',
      'thumb': 'assets/img/work/main-page/thumbs/work-211.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/FPzYzRZy8tA',
      'class': 'animation',
      'index': 219
    });

    this.album.push({
      'src': 'assets/img/work/main-page/212.jpg',
      'caption': 'NDB',
      'thumb': 'assets/img/work/main-page/thumbs/work-212.jpg',
      'type': 'video',
      'link': 'https://youtube.com/embed/vEq8q7cdOJE',
      'class': 'animation',
      'index': 220
    });



    // 224
    this.album.push({
      'src': 'assets/img/work/main-page/224.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-224.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/xsjKmYzTmEQ',
      'class': 'tv',
      'index': 3011
    });

    // 213
    this.album.push({
      'src': 'assets/img/work/main-page/213.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-213.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/oyC3wIL_Aow',
      'class': 'tv',
      'index': 3010
    });

    // 214
    this.album.push({
      'src': 'assets/img/work/main-page/214.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-214.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/wXY6_k9hO5w',
      'class': 'tv',
      'index': 3007
    });

    // 215
    this.album.push({
      'src': 'assets/img/work/main-page/215.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-215.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/d3OkJj7YRcs',
      'class': 'tv',
      'index': 3009
    });

    // 216
    this.album.push({
      'src': 'assets/img/work/main-page/216.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-216.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/pbSjJO1IeB0',
      'class': 'tv',
      'index': 3008
    });

    // 217 - moved from last displayed position to FIRST
    this.album.push({
      'src': 'assets/img/work/main-page/217.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-217.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/irv3Gal4Ong',
      'class': 'tv',
      'index': 3012
    });

    // 218
    this.album.push({
      'src': 'assets/img/work/main-page/218.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-218.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/1mU5Z16DNJ8',
      'class': 'tv',
      'index': 3003
    });

    // 219
    this.album.push({
      'src': 'assets/img/work/main-page/219.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-219.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/os-iWLM46iA',
      'class': 'tv',
      'index': 3001
    });

    // 220
    this.album.push({
      'src': 'assets/img/work/main-page/220.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-220.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/RfbFWljswmw',
      'class': 'tv',
      'index': 3005
    });

    // 221
    this.album.push({
      'src': 'assets/img/work/main-page/221.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-221.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/qzKXYEOw9CE',
      'class': 'tv',
      'index': 3002
    });

    // 222
    this.album.push({
      'src': 'assets/img/work/main-page/222.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-222.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/86JgDFtUaio',
      'class': 'tv',
      'index': 3006
    });

    // 223
    this.album.push({
      'src': 'assets/img/work/main-page/223.jpg',
      'caption': 'Ad Campaign',
      'thumb': 'assets/img/work/main-page/thumbs/work-223.jpg',
      'type': 'video',
      'link': 'https://www.youtube.com/embed/b4FJ0tUWcaA',
      'class': 'tv',
      'index': 3004
    });

  }

  // Filter Configurations //

  filter(type) {

    this.items = [];
    console.log(this.items)
    // this.filteredAlbum = [];
    this.page = 0;
    console.log('ITEM Type', type)
    this.setActiveTabSwitch(type);
    if (type == '') {
      this.filteredAlbum = [...this.album];
    } else {
      this.filteredAlbum = [...this.album];
      this.filteredAlbum = this.album.filter(item => item.class === type);
    }


    this.loadMoreItems(); // Load the first page when component initializes

  }

  resetFilter() {
    this.filteredAlbum = [...this.album];
  }

  setActiveTabSwitch(item: string): void {
    // Reset all tabs first
    this.resetAllTabs();

    switch (item) {
      case 'digital':
        this.activeTab_digital = 'active';
        break;
      case 'branding':
        this.activeTab_branding = 'active';
        break;
      case '*':
        this.activeTab_all = 'active';
        break;
      case 'tv':
        this.activeTab_tv = 'active';
        break;
      case 'animation':
        this.activeTab_animation = 'active';
        break;
      case 'news-letter':
        this.activeTab_news_letter = 'active';
        break;
      case 'logo':
        this.activeTab_logo = 'active';
        break;
      default:
        this.activeTab_all = 'active';
    }


  }

  private resetAllTabs(): void {
    this.activeTab_all = '';
    this.activeTab_branding = '';
    this.activeTab_digital = '';
    this.activeTab_tv = '';
    this.activeTab_animation = '';
    this.activeTab_news_letter = '';
    this.activeTab_logo = '';
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    if (this.isLoading) return;

    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    // Check if we're near the bottom
    if ((scrollTop + windowHeight + this.scrollDistance) >= documentHeight) {
      this.loadMoreItems();
    }
  }

  loadMoreItems() {
    if (this.isLoading) return;
    this.isLoading = true;

    if (!this.filteredAlbum || !this.filteredAlbum.length) {
      console.log('No data in filteredAlbum');
      this.isLoading = false;
      this.hasMoreItems = false;
      return;
    }

    const startIndex = this.page * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.filteredAlbum.length);
    const newItems = this.filteredAlbum.slice(startIndex, endIndex);

    if (newItems.length > 0) {
      // this.spinner.show();
      this.items = [...this.items, ...newItems];
      this.page++;
      // this.spinner.hide();
      console.log("all items", this.album);
      console.log("current array", this.items);
      console.log("new array", newItems);

    } else {
      this.hasMoreItems = false;
    }

    this.isLoading = false;
  }

  // Loadin Configurations

  isVisible = false; // Start hidden

  showPreloader() {
    this.isVisible = true; // Fade in

    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.hidePreloader();
    }, 450);
  }

  hidePreloader() {
    this.isVisible = false; // Fade out
  }


  // Pop up Configurations

  showPopup = false;
  selectedVideoUrl = '';

  openPopup(url: string) {
    console.log(url)
    this.selectedVideoUrl = url;
    this.showPopup = true;
  }

  closePopup() {
    this.showPopup = false;
  }



}



// Content Order and Ranges of Index for Priority

// Brandin & Promotions
// 1000 
// Digital Marketing
// 2000
// TV Ads
// 3000
// Video Creations
// 4000
// E- News Letter
// 5000
// Logo
// 6000
// All
// No Ranges Apply